import { FC } from "react";

import { ClassSessionCategory } from "components/server-types";
import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";
import { useAppSelector } from "store/index";
import { selectClassSessionCategoryBySectionId } from "store/selectors";
import { useAv } from "utils/av";

export const SessionInProgressChip: FC<{ sectionId: string }> = ({ sectionId }) => {
  const { isAvSupportedInBrowser } = useAv();
  const classSessionCategory = useAppSelector((state) =>
    selectClassSessionCategoryBySectionId(state, sectionId),
  );

  if (
    !classSessionCategory ||
    (classSessionCategory === ClassSessionCategory.VIRTUAL && !isAvSupportedInBrowser)
  ) {
    return null;
  }

  return <Chip kind="blue">{t("home.session_in_progress")}</Chip>;
};
